module.exports = __webpack_public_path__ + "static/img/bg-shadow.58234f00.png";